module.exports = __webpack_public_path__ + "img/HOTELBEDS.6f0d9d9a.png";